import { useId, useState } from 'react';
import { cn } from '@helpers/cn';
import { TProps } from './types/TProps';

export const ResponsivePanels = ({
  firstLabel,
  secondLabel,
  first,
  second,
  className,
  activePanel,
  onPanelChange,
}: TProps) => {
  const [internalActive, setInternalActive] = useState<'first' | 'second'>('first');
  const active = activePanel ?? internalActive;
  const setActive = (panel: 'first' | 'second') => {
    setInternalActive(panel);
    onPanelChange?.(panel);
  };
  const id = useId();

  return (
    <div className="min-w-0">
      <div className="mb-3 flex flex-wrap gap-2 xl:hidden" role="group" aria-label="Workspace panels">
        <button
          type="button"
          aria-pressed={active === 'first'}
          aria-controls={`${id}-first`}
          onClick={() => setActive('first')}
          className="min-h-11 rounded border border-border px-4 text-title aria-pressed:bg-tint"
        >
          {firstLabel}
        </button>
        <button
          type="button"
          aria-pressed={active === 'second'}
          aria-controls={`${id}-second`}
          onClick={() => setActive('second')}
          className="min-h-11 rounded border border-border px-4 text-title aria-pressed:bg-tint"
        >
          {secondLabel}
        </button>
      </div>
      <div className={cn('grid min-w-0 grid-cols-1 gap-4 xl:grid-cols-2', className)}>
        <section
          id={`${id}-first`}
          aria-label={firstLabel}
          className={cn('min-w-0 xl:block', active !== 'first' && 'hidden')}
        >
          {first}
        </section>
        <section
          id={`${id}-second`}
          aria-label={secondLabel}
          className={cn('min-w-0 xl:block', active !== 'second' && 'hidden')}
        >
          {second}
        </section>
      </div>
    </div>
  );
};
